module.exports = {"451026100":"城厢镇","451026101":"平孟镇","451026102":"龙合镇","451026200":"坡荷乡","451026203":"德隆乡","451026204":"百合乡","451026205":"百南乡","451026207":"百省乡","451026208":"百都乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451026.json
// module id = 2146
// module chunks = 0